
const limitChar = (val: string, limit: number = 100) => `${val.substring(0, limit)}${val.length > limit ? ' ...' : ''}`
export default limitChar
